var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"login-info-section"},[_c('div',{staticClass:"title"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.parent.$t('info-section.login-desc')))])])}
var staticRenderFns = []

export { render, staticRenderFns }